import { textToCharacterSpeechMutationRequest } from '../../requests/text-to-character-speech.mutation.ts';
import { TextToCharacterSpeechInput } from '../../types/text-to-character-speech.types.ts';

import { BaseSpeechUtil } from './base-speech.util.ts';

export class TextToSpeechUtil extends BaseSpeechUtil<TextToCharacterSpeechInput> {
  private static _instance: TextToSpeechUtil;

  public static get instance(): TextToSpeechUtil {
    if (!TextToSpeechUtil._instance) {
      TextToSpeechUtil._instance = new TextToSpeechUtil();
    }
    return TextToSpeechUtil._instance;
  }

  protected override async onConnected(params: TextToCharacterSpeechInput): Promise<void> {
    await textToCharacterSpeechMutationRequest(params);
  }
}

export const getTextToSpeechUtil = (): TextToSpeechUtil => TextToSpeechUtil.instance;
